import React from "react"
import {OneChoice, MultipleChoices, LongText, ShortText} from "./"

export const SurveyQuestion = ({data={}}) => {
    const {type} = data
    switch (type) {
        case "radio":
            return <OneChoice data={data}/>
        case "multiple":
            return <MultipleChoices data={data}/>
        case "shortText":
            return <ShortText data={data}/>
        case "longText":
            return <LongText data={data}/>
        default:
            return <div>Not found</div>
    }
}
